import React, { useState, useEffect, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getOrganizationInfo, getMyWeddings, createWeddingByOrganization, updateWeddingByOrg } from '../../services/apiService';
import { QRCodeSVG } from 'qrcode.react';

export default function OrgDashboard() {
  const [info, setInfo] = useState(null);
  const [weddings, setWeddings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [creationResult, setCreationResult] = useState(null);
  
  const [selectedQrCode, setSelectedQrCode] = useState(null);
  
  const [searchQuery, setSearchQuery] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [editName, setEditName] = useState('');
  const [editAlbums, setEditAlbums] = useState([]);

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: '', date: '', albumMode: 'default'
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [infoData, weddingsData] = await Promise.all([
        getOrganizationInfo(),
        getMyWeddings()
      ]);
      setInfo(infoData);
      setWeddings(weddingsData);
    } catch (err) {
      alert("Bilgiler alınamadı: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleCreateNew = () => {
    if (info && info.credits <= 0) {
      // Yetersiz kredi
      if (window.confirm("Yetersiz krediniz var! Yeni kredi / düğün paketi satın almak ister misiniz?")) {
        navigate('/organization/satin-al');
      }
      return;
    }
    setIsModalOpen(true);
  };

  const handleCreateWedding = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const res = await createWeddingByOrganization(formData);
      setCreationResult({ ...res, tempCode: res.wedding.code }); // Display QR code info
      fetchData(); // Refresh list & credits
    } catch (err) {
      alert('Hata: ' + err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleEditStart = (wedding) => {
    setEditingId(wedding._id);
    setEditName(wedding.name || '');
    setEditAlbums([...(wedding.albumNames || [])]);
  };

  const handleEditCancel = () => {
    setEditingId(null);
    setEditName('');
    setEditAlbums([]);
  };

  const handleEditSave = async (weddingId) => {
    if (!editName.trim()) {
      alert("Düğün adı boş olamaz.");
      return;
    }
    try {
      await updateWeddingByOrg(weddingId, { name: editName, albumNames: editAlbums });
      alert("Düğün bilgileri başarıyla güncellendi.");
      setEditingId(null);
      fetchData();
    } catch (err) {
      alert("Güncelleme hatası: " + err.message);
    }
  };

  const filteredWeddings = useMemo(() => {
    if (!searchQuery.trim()) return weddings;
    const q = searchQuery.toLowerCase('tr-TR');
    return weddings.filter(w => (w.name || '').toLowerCase('tr-TR').includes(q));
  }, [weddings, searchQuery]);

  if (loading) return <div style={{textAlign:'center', marginTop:50}}>Yükleniyor...</div>;

  return (
    <div className="min-h-screen bg-rose-50" style={{ padding: '20px' }}>
      <header style={{ marginBottom: 20, display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'white', padding: '20px', borderRadius: '10px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Hoş Geldiniz, {info?.name}</h1>
          <p className="text-gray-500">Yetkili: {info?.contactName}</p>
        </div>
        <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
          <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', padding: '10px 15px', borderRadius: '8px', textAlign: 'center' }}>
            <div style={{ fontSize: '11px', color: '#166534', fontWeight: 'bold' }}>KALAN DÜĞÜN KREDİSİ</div>
            <div style={{ fontSize: '24px', color: '#15803d', fontWeight: '900' }}>{info?.credits}</div>
          </div>
          <button onClick={() => navigate('/organization/satin-al')} className="bg-[#e45078] text-white px-4 py-3 rounded-lg font-bold hover:bg-rose-600">
            + Kredi / Paket Satın Al
          </button>
        </div>
      </header>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 15, flexWrap: 'wrap', gap: '10px' }}>
        <h2 className="text-xl font-bold text-gray-700">Düğünleriniz</h2>
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          <input 
            type="text" 
            placeholder="Düğün Adı Ara..." 
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            style={{ padding: '8px 15px', borderRadius: '5px', border: '1px solid #d1d5db', outline: 'none' }}
          />
          <button onClick={handleCreateNew} className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 whitespace-nowrap">
            + Yeni Düğün Başlat (1 Kredi)
          </button>
        </div>
      </div>

      <div style={{ background: 'white', borderRadius: '10px', overflow: 'hidden', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
        <table style={{ width: '100%', textAlign: 'left', borderCollapse: 'collapse' }}>
          <thead style={{ background: '#f9fafb', borderBottom: '1px solid #e5e7eb' }}>
            <tr>
              <th style={{ padding: 15 }}>Düğün Adı</th>
              <th style={{ padding: 15 }}>Albümler</th>
              <th style={{ padding: 15 }}>Karekod Kodu</th>
              <th style={{ padding: 15 }}>Tarih</th>
              <th style={{ padding: 15 }}>Paket Modeli</th>
              <th style={{ padding: 15 }}>İşlemler</th>
            </tr>
          </thead>
          <tbody>
            {filteredWeddings.length === 0 ? (
              <tr><td colSpan="6" style={{ padding: 20, textAlign: 'center', color: '#6b7280' }}>Düğün bulunamadı.</td></tr>
            ) : (
              filteredWeddings.map(w => (
                <tr key={w._id} style={{ borderBottom: '1px solid #f3f4f6' }}>
                  <td style={{ padding: 15 }}>
                    {editingId === w._id ? (
                      <input 
                        type="text" 
                        value={editName} 
                        onChange={(e) => setEditName(e.target.value)} 
                        style={{ border: '1px solid #ccc', padding: '5px', borderRadius: '4px', width: '100%' }}
                      />
                    ) : (
                      <strong>{w.name}</strong>
                    )}
                  </td>
                  <td style={{ padding: 15 }}>
                    {editingId === w._id && editAlbums.length > 0 ? (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                        {editAlbums.map((album, idx) => (
                          <input 
                            key={idx}
                            type="text" 
                            value={album} 
                            onChange={(e) => {
                              const newArr = [...editAlbums];
                              newArr[idx] = e.target.value;
                              setEditAlbums(newArr);
                            }}
                            style={{ border: '1px solid #ccc', padding: '2px 5px', borderRadius: '4px', fontSize: '0.85rem' }}
                          />
                        ))}
                      </div>
                    ) : (
                      <span style={{ fontSize: '0.85rem', color: '#555' }}>
                        {w.albumNames?.join(', ') || 'Yok'}
                      </span>
                    )}
                  </td>
                  <td style={{ padding: 15 }}><span style={{ backgroundColor: '#f3f4f6', padding: '4px 8px', borderRadius: '4px', fontFamily: 'monospace' }}>{w.code}</span></td>
                  <td style={{ padding: 15 }}>{new Date(w.date).toLocaleDateString('tr-TR')}</td>
                  <td style={{ padding: 15 }}>{w.albumMode === 'dual' ? '2 Albüm' : w.albumMode === 'triple' ? '3 Albüm' : 'Standart'}</td>
                  <td style={{ padding: 15 }}>
                    {editingId === w._id ? (
                       <div style={{ display: 'flex', gap: '5px' }}>
                          <button onClick={() => handleEditSave(w._id)} className="bg-green-500 text-white px-2 py-1 rounded text-xs">Kaydet</button>
                          <button onClick={handleEditCancel} className="bg-gray-400 text-white px-2 py-1 rounded text-xs">İptal</button>
                       </div>
                    ) : (
                       <div style={{ display: 'flex', gap: '10px' }}>
                          <button onClick={() => handleEditStart(w)} className="text-blue-600 hover:underline text-sm font-medium">Düzenle</button>
                          <button onClick={() => setSelectedQrCode(w.code)} className="text-rose-600 hover:underline text-sm font-medium">Karekod Göster</button>
                       </div>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Yeni Düğün Modalı */}
      {isModalOpen && (
        <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50 }}>
          <div style={{ background: 'white', padding: 30, borderRadius: 10, width: '100%', maxWidth: 450, position: 'relative' }}>
            <button onClick={() => { setIsModalOpen(false); setCreationResult(null); }} style={{ position: 'absolute', top: 15, right: 15, fontSize: 24, padding: 0, background: 'none', border: 'none', cursor: 'pointer' }}>&times;</button>
            
            {creationResult ? (
              <div style={{ textAlign: 'center' }}>
                <h3 style={{ color: 'green', fontSize: 20, marginBottom: 15 }}>Düğün Başarıyla Oluşturuldu!</h3>
                <p>1 Krediniz düşüldü.</p>
                <div style={{ background: '#f5f5f5', padding: '15px', borderRadius: '5px', marginTop: 10, marginBottom: 15 }}>
                  <p><strong>Düğün / Karekod:</strong> <span style={{fontSize:24, fontWeight:'bold', letterSpacing:2}}>{creationResult.tempCode}</span></p>
                </div>
                <Link to={`/owner/w/${creationResult.tempCode}`} className="bg-[#e45078] text-white px-4 py-2 rounded-md hover:bg-rose-600 inline-block">
                  Düğün Paneline Git
                </Link>
              </div>
            ) : (
              <form onSubmit={handleCreateWedding} style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
                <h2 style={{ fontSize: 22, fontWeight: 'bold', marginBottom: 10 }}>Yeni Düğün Başlat</h2>
                <div>
                  <label style={{ display:'block', fontSize: 14, fontWeight:'bold', marginBottom:5 }}>Çiftin Adı (Düğün Adı)</label>
                  <input type="text" style={{ width:'100%', padding: '10px', border:'1px solid #d1d5db', borderRadius:'5px' }} value={formData.name} onChange={e => setFormData({...formData, name: e.target.value})} required placeholder="Selin & Ozan" />
                </div>
                <div>
                  <label style={{ display:'block', fontSize: 14, fontWeight:'bold', marginBottom:5 }}>Tarih</label>
                  <input type="date" style={{ width:'100%', padding: '10px', border:'1px solid #d1d5db', borderRadius:'5px' }} value={formData.date} onChange={e => setFormData({...formData, date: e.target.value})} required />
                </div>
                <div>
                  <label style={{ display:'block', fontSize: 14, fontWeight:'bold', marginBottom:5 }}>Paket Modeli</label>
                  <select style={{ width:'100%', padding: '10px', border:'1px solid #d1d5db', borderRadius:'5px' }} value={formData.albumMode} onChange={e => setFormData({...formData, albumMode: e.target.value})}>
                    <option value="default">Standart (Tek Ekran)</option>
                    <option value="dual">2 Albümlü (Gelin/Damat)</option>
                    <option value="triple">3 Albümlü (Hazırlık, Nikah, Eğlence) SINIRSIZ KOTA</option>
                  </select>
                </div>
                <button type="submit" disabled={isSubmitting} style={{ background: '#2563eb', color: 'white', padding: '12px', borderRadius: '5px', fontWeight: 'bold', marginTop: 10 }}>
                  {isSubmitting ? 'İşleniyor...' : '1 Kredi Harca ve Oluştur'}
                </button>
              </form>
            )}
          </div>
        </div>
      )}

      {/* Karekod Göster Modalı */}
      {selectedQrCode && (
        <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 60 }}>
          <div style={{ background: 'white', padding: 30, borderRadius: 10, width: '100%', maxWidth: 350, position: 'relative', textAlign: 'center' }}>
            <button onClick={() => setSelectedQrCode(null)} style={{ position: 'absolute', top: 15, right: 15, fontSize: 24, padding: 0, background: 'none', border: 'none', cursor: 'pointer' }}>&times;</button>
            <h3 style={{ fontSize: 18, fontWeight: 'bold', marginBottom: 20 }}>Düğün Karekodu</h3>
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
               <QRCodeSVG value={`${window.location.origin}/w/${selectedQrCode}`} size={200} />
            </div>
            <p style={{ fontSize: 13, color: '#6b7280' }}>Bu karekodu misafirlerinize okutarak fotoğraflara ulaşmalarını sağlayabilirsiniz.</p>
          </div>
        </div>
      )}
    </div>
  );
}
